import { createSelector } from '@ngrx/store';
import { appSettingsState } from '../root';

export const isOnline = createSelector(appSettingsState, (appSettings) => appSettings.isOnline);
